import { HelpNetworkIcon } from './HelpNetworkIcon';

/**
 * author: Austin Andrews
 * id FE0A3DAC-0D3D-4D49-A869-F78B44B26E35
 * name help-network
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-network.svg
 * tags
 */
export const QuestionNetworkIcon = HelpNetworkIcon;
export default QuestionNetworkIcon